import { Icon16Attention } from '@figma/fpl-icons/icon-16-attention';
import { Icon16Info } from '@figma/fpl-icons/icon-16-info';
import { Icon16Warning } from '@figma/fpl-icons/icon-16-warning';
import { Icon24Attention } from '@figma/fpl-icons/icon-24-attention';
import { Icon24Info } from '@figma/fpl-icons/icon-24-info';
import { Icon24Warning } from '@figma/fpl-icons/icon-24-warning';
import { useString } from '../settings/settings.strings.js';
import { dangerVariant, warnVariant, successVariant, brandVariant, defaultVariant, insetType, insetModalType, informationalType, inlineType, fullWidthType } from './banner.css.js';

function getIcon(variant, type) {
    switch (variant) {
        case 'warn':
            return type === 'inset-modal' ? Icon16Warning : Icon24Warning;
        case 'danger':
            return type === 'inset-modal' ? Icon16Attention : Icon24Attention;
        case 'success':
        case 'default':
        case 'brand':
            return type === 'inset-modal' ? Icon16Info : Icon24Info;
    }
}
function useMessagePrefix(variant) {
    const warning = useString('warning');
    const danger = useString('danger');
    switch (variant) {
        case 'warn':
            return warning;
        case 'danger':
            return danger;
        case 'success':
        case 'default':
        case 'brand':
            return null;
    }
}
const variantStyles = {
    default: defaultVariant,
    brand: brandVariant,
    success: successVariant,
    warn: warnVariant,
    danger: dangerVariant,
};
const typeStyles = {
    'full-width': fullWidthType,
    inline: inlineType,
    informational: informationalType,
    'inset-modal': insetModalType,
    inset: insetType,
};

export { getIcon, typeStyles, useMessagePrefix, variantStyles };
//# sourceMappingURL=banner.utils.js.map
